module.exports = __webpack_public_path__ + "static/img/natasha_pictgrid15_960x851.9e2dd2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/natasha_pictgrid15_960x851.jpg
// module id = g5c+
// module chunks = 0